import { render } from "./CurrentAuths.vue?vue&type=template&id=b9476676"
import script from "./CurrentAuths.vue?vue&type=script&lang=js"
export * from "./CurrentAuths.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__